import styled from 'styled-components'
import tokens from '@gympass/yoga-tokens'

import { H3, H6 } from '@components/Text'
import SMBContainer from '@components/Container'
import getBreakpoint from '@client/utils/breakpoints'

export const MainWrapper = styled.section`
  padding-top: 40px;
  padding-bottom: 98px;
  background-color: var(--white);

  @media (min-width: ${getBreakpoint('md')}px) {
    padding-top: 72px;
    padding-bottom: 105px;
  }
`

export const Container = styled(SMBContainer)`
  @media (min-width: ${getBreakpoint('md')}px) {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Title = styled(H3)`
  font-style: normal;
  font-weight: 500;
  line-height: 37px;

  @media (min-width: ${getBreakpoint('md')}px) {
  }
`

export const Subtitle = styled(H6)`
  font-style: normal;
  font-weight: normal;
  margin-top: 16px;
  margin-bottom: 48px;
  color: ${tokens.colors.deep};

  @media (min-width: ${getBreakpoint('md')}px) {
    margin-top: 8px;
    margin-bottom: 56px;
  }
`
